<div *ngIf="post" class="details-mobile-layout" [class.details-mobile-layout--compact]="compactViewport">
  <div class="details-mobile-media">
    <app-details-header
      class="details-mobile-header"
      [post]="post"
      [mode]="mode"
      [isWeb]="true"
      [isGuest]="guest"
      (showGuestModal)="userModal()"
    ></app-details-header>

    <swiper-container class="details-mobile-swiper" [pagination]="{ clickable: true }">
      <swiper-slide
        class="details-mobile-media__slide"
        *ngFor="let image of getMediaImages(); let imageIndex = index"
      >
        <button
          type="button"
          class="details-mobile-media__trigger"
          (click)="openImageViewer(imageIndex)"
        >
          <div
            class="details-mobile-media__image !bg-cover !bg-center"
            [ngStyle]="{ background: 'url(' + image.image_url + ')' }"
          >
            <div class="image-overlay"></div>
          </div>
        </button>
      </swiper-slide>
    </swiper-container>
  </div>

  <div class="details-mobile-sheet bg-gradient-3 text-white">
    <div class="details-mobile-sheet__scroll px-6" [class.details-mobile-sheet__scroll--compact]="compactViewport">
      <ion-label class="text-lg font-medium">{{ post.title }}</ion-label>
      <ion-label class="text-[12px] flex items-center">
        <ion-icon
          src="../../../assets/svg/location3.svg"
          class="mr-1 text-[14px]"
        ></ion-icon>
        {{ post.address || post.map_location }}
      </ion-label>
      <div
        class="rounded-md w-fit px-2 h-6 flex items-center"
        [class]="post.type === 'found' ? 'bg-[#4BC287]' : 'bg-[#F34545]'"
      >
        <ion-label class="uppercase text-[11px]">
          {{ "DETAILS_MOBILE.OBJECT" | translate }}
          {{
            post.type === "found"
              ? ("DETAILS_MOBILE.FOUND" | translate)
              : ("DETAILS_MOBILE.LOST" | translate)
          }}
        </ion-label>
      </div>

      <ion-segment mode="md" color="light" class="w-full" [value]="activeSegment" (ionChange)="onSegmentChange($event)">
        <ion-segment-button value="first">
          <ion-label class="capitalize text-white text-sm segment-label">{{
            "DETAILS_MOBILE.INFORMATION" | translate
          }}</ion-label>
        </ion-segment-button>
        <ion-segment-button value="second">
          <ion-label class="capitalize text-white text-sm segment-label p-2">{{
            "DETAILS_MOBILE.ATTRIBUTES" | translate
          }}</ion-label>
        </ion-segment-button>
      </ion-segment>

      <div
        #activeSegmentPanel
        class="details-mobile-segment-panel"
        [style.minHeight.px]="activeSegmentPanelMinHeight || null"
        *ngIf="activeSegment === 'first'"
      >
        <p class="text-[13px]">{{ post.description }}</p>
        <p
          class="details-mobile-publication-date text-[12px]"
          *ngIf="
            post?.created_at ||
            post?.published_at ||
            post?.createdAt ||
            post?.publishedAt
          "
        >
          {{ "DETAILS_MOBILE.PUBLICATION_DATE" | translate }}:
          {{
            post.created_at ||
              post.published_at ||
              post.createdAt ||
              post.publishedAt | date : "dd/MM/yyyy"
          }}
        </p>
      </div>
      <div
        #activeSegmentPanel
        class="details-mobile-segment-panel"
        [style.minHeight.px]="activeSegmentPanelMinHeight || null"
        *ngIf="activeSegment === 'second'"
      >
        <div class="flex flex-col gap-3">
          <div
            *ngFor="let attr of post.article_attributes"
            class="flex items-center justify-between"
          >
            <ion-label class="text-[13px] font-medium"
              >{{ attr.attribute_name }}:</ion-label
            >

            <div class="flex items-center gap-2">
              <div
                *ngIf="attr.attribute?.type === 'color'"
                class="w-5 h-5 rounded-full border border-gray-300"
                [ngStyle]="{ 'background-color': attr.value }"
              ></div>

              <ion-label
                *ngIf="attr.attribute?.type !== 'color'"
                class="text-[13px]"
                >{{ attr.value }}</ion-label
              >
            </div>
          </div>

          <ion-label
            *ngIf="
              !post.article_attributes || post.article_attributes.length === 0
            "
            class="text-[13px] text-center italic"
          >
            {{ "DETAILS_MOBILE.NO_ATTRIBUTES" | translate }}
          </ion-label>
        </div>
      </div>

      <div *ngIf="mode !== 'commission' && !isOwner()" class="public-profile-share-callout mt-4">
        <img
          src="../../../assets/svg/public-profile-share.svg"
          alt=""
          aria-hidden="true"
          class="public-profile-share-callout__icon"
        />
        <p class="public-profile-share-callout__text">
          {{ getInfoTextKey() | translate }}
        </p>
      </div>

      <ion-button
        *ngIf="mode !== 'commission'"
        [disabled]="isOwner()"
        color="light"
        mode="ios"
        class="app-shadow mt-4"
        (click)="!guest ? openContactRequestDialog() : userModal()"
        >{{ getContactButtonKey() | translate }}</ion-button
      >

      <app-dialog
        [show]="showContactRequestDialog"
        [close]="true"
        (toggle)="cancelContactRequestDialog()"
      >
        <div class="flex flex-col gap-4 p-2 pt-4">
          <h3 *ngIf="post?.type === 'lost'" class="text-lg font-semibold text-center">
            {{ 'PUBLIC_PROFILE_SHARE_DIALOG.TITLE' | translate }}
          </h3>
          <div class="public-profile-share-callout public-profile-share-callout--dialog">
            <ion-label class="public-profile-share-callout__text"
              [innerHTML]="getContactDialogBodyKey() | translate">
            </ion-label>
          </div>

          <ng-container *ngIf="post?.type === 'lost'">
            <ion-button size="small" color="primary" class="w-full" (click)="confirmContactRequest()">
              {{ 'DIALOG.NOTIFY_OWNER_BUTTON' | translate }}
            </ion-button>
          </ng-container>

          <ng-container *ngIf="post?.type !== 'lost'">
            <ion-button size="small" color="primary" class="w-full" (click)="confirmContactRequest()">
              {{ 'DIALOG.CONTACT' | translate }}
            </ion-button>
          </ng-container>
        </div>
      </app-dialog>

      <div *ngIf="mode === 'commission'" class="details-mobile-sheet__footer-block">
        <hr class="mb-6" />
        <div
          class="flex gap-4"
          (click)="navigate('/user-profile/' + post.user.id)"
        >
          <div
            class="h-[38px] w-[38px] rounded-[5px] !bg-cover !bg-center"
            [ngStyle]="{
              background:
                'url(' +
                (post.user.photo_perfil ||
                  'assets/images/team-profile-placeholder.jpg') +
                ')'
            }"
          ></div>
          <div class="flex flex-col">
            <ion-label class="text-sm font-medium">{{
              post.user.name
            }}</ion-label>
            <ion-label class="text-[11px] font-light">{{
              "DETAILS_MOBILE.VIEW_PROFILE" | translate
            }}</ion-label>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ion-modal
  *ngIf="showImageViewer"
  cssClass="details-mobile-image-viewer-modal"
  [isOpen]="showImageViewer"
  [backdropDismiss]="true"
  [canDismiss]="true"
  (ionModalDidDismiss)="closeImageViewer()"
>
  <ng-template>
    <div class="details-mobile-image-viewer" role="dialog" aria-modal="true">
      <button
        type="button"
        class="details-mobile-image-viewer__close"
        aria-label="Close image viewer"
        (click)="closeImageViewer()"
      >
        <ion-icon name="close-outline"></ion-icon>
      </button>

      <swiper-container
        class="details-mobile-image-viewer__swiper"
        [pagination]="{ clickable: true }"
        [attr.initial-slide]="selectedImageIndex"
        zoom="true"
        zoom-max-ratio="4"
      >
        <swiper-slide *ngFor="let image of getMediaImages()">
          <div class="swiper-zoom-container details-mobile-image-viewer__zoom-container">
            <img
              class="details-mobile-image-viewer__image"
              [src]="image.image_url"
              alt=""
              draggable="false"
            />
          </div>
        </swiper-slide>
      </swiper-container>
    </div>
  </ng-template>
</ion-modal>
